const jobs = [
  {
    title: "Impact-Rated Glass",
    description: "HVHZ needs licensed contractor.",
  },
  {
    title: "Hurricane Glass",
    description: "Wind-resistant needs permits.",
  },
  {
    title: "Insurance Claim Work",
    description: "Needs licensed contractor.",
  },
  {
    title: "Storefront Glass",
    description: "Commercial specialty contractor.",
  },
];

export default function ReferOut() {
  return (
    <section className="w-full bg-[#fefce8] py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-roboto font-bold text-2xl md:text-[32px] text-[#064e3b] mb-3">
            Jobs We Refer Out
          </h2>
          <p className="text-gray-600 text-base max-w-[720px] mx-auto">
            Need licensed Florida contractor. We refer at no cost.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {jobs.map((j) => (
            <div
              key={j.title}
              className="bg-white rounded-xl p-5 border border-gray-200 border-t-4 border-t-[#ea580c]"
            >
              <h3 className="font-bold text-base text-[#064e3b] mb-1">{j.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{j.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}